import React from "react";
import Select from "react-select";
import { CircularAvatar } from "../../commons";
import { components } from "react-select";
import { ClientWiseMonthlyTimesheetType } from "../../../redux/timeSheet/timeSheetType";
import CommonMonthSelect from "../../commons/CommonMonthSelect/CommonMonthSelect";

export type DropDownUserType = {
  value: number | null;
  label: string;
};

type AppProps = {
  finalClientList: DropDownUserType[];
  client: DropDownUserType;
  setClient: React.Dispatch<React.SetStateAction<DropDownUserType>>;
  setClientOffset: React.Dispatch<React.SetStateAction<number>>;
  clientFetching: boolean;
  setClientText: React.Dispatch<React.SetStateAction<string>>;
  startDate: string;
  endDate: string;
  handleStartDateChange: (date: string) => void;
  handleEndDateChange: (date: string) => void;
  toggle: boolean;
  setToggle: React.Dispatch<React.SetStateAction<boolean>>;
  handleSubmitData: () => void;
  currentStartDate: string;
  currentEndDate: string;
  clientWiseMonthlyTimesheetReportList: ClientWiseMonthlyTimesheetType[] | [];
  token: string | null;
  isGetClientWiseMonthlyReportPresent:boolean;
};
const TimesheetClientWiseMonthlyReportHeader = ({
  finalClientList,
  client,
  setClient,
  setClientOffset,
  clientFetching,
  setClientText,
  startDate,
  endDate,
  handleStartDateChange,
  handleEndDateChange,
  toggle,
  setToggle,
  handleSubmitData,
  currentStartDate,
  currentEndDate,
  clientWiseMonthlyTimesheetReportList,
  token,
  isGetClientWiseMonthlyReportPresent
}: AppProps) => {
  const checkClientBottom = () => {
    setClientOffset && setClientOffset((prev: number) => prev + 20);
  };

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label.split("%")[0]}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };

  return (
    <>
      <div className="d-flex pt-3 pl-3 align-items-center">
        <div className="col-md-3 pr-0">
          <div className="form-group">
            <div className="col-md-12 p-0 pr-1">
              <label htmlFor="employeeId">Select Client </label>
              <Select
                options={finalClientList}
                value={client}
                onChange={(value: any) => setClient && setClient(value)}
                isSearchable={true}
                components={{ Option }}
                isLoading={clientFetching}
                onMenuClose={() => setClientOffset?.(0)}
                onMenuScrollToBottom={checkClientBottom}
                onInputChange={(e) => {
                  setClientText?.(e);
                  setClientOffset?.(0);
                }}
              />
            </div>
          </div>
        </div>
        <div className="form-group ml-2">
          <label>Date</label>
          <div>
            <CommonMonthSelect
              setToggle={setToggle}
              toggle={toggle}
              startDate={startDate}
              endDate={endDate}
              handleStartDateChange={handleStartDateChange}
              handleEndDateChange={handleEndDateChange}
            />
          </div>
        </div>

        <div className="col-md-1">
          {isGetClientWiseMonthlyReportPresent &&
          <button
            className="btn btn-primary mt-1 pt-2 pb-2"
            onClick={handleSubmitData}
            disabled={!startDate?.length || !endDate?.length || !client?.value}
          >
            Apply
          </button>
}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
        </div>
      </div>
    </>
  );
};

export default TimesheetClientWiseMonthlyReportHeader;
